export const emptyNotify = {
  severity: "High",
  short: "",
  details: "",
  link: ""
};
